var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"border":"1px solid #DFDFDF","border-radius":"6px","padding":"8px 8px 8px 4px"}},[_c('LineChart',{staticStyle:{"height":"250px"},attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }